const t = {
  name: "ArrowBottom",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 18.5857L5.00015 12.5858L3.58594 14L12.0001 22.4142L20.4144 14L19.0002 12.5858L13 18.586L13 2L11 2L11 18.5857Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ArrowBottom
};
